/*
eslint class-methods-use-this: ["error", {
  "exceptMethods": [
    calculateWalletCharge
  ]
}]
*/
/* global logger */
const { slaChargeType } = require('pando-constants');

class AcceptanceBreach {
  calculateWalletCharge(data, prevTransporterId = null) {
    let amount = 0;
    const { order, sla: slaCharge, clientConfig: config } = data;
    const placementReliability = config && config.placement_reliability;
    const previousTransporter = order.previous_transporters[order.previous_transporters.length - 1];
    if (slaCharge && slaCharge.length) {
      amount = slaCharge[0].acceptance_delay_cost;
      if (placementReliability && placementReliability.enabled
        && placementReliability.penalty_charges_type === slaChargeType.PERCENTAGE) {
        amount = (slaCharge[0].acceptance_delay_cost / 100);
        if (order.previous_transporters.length) {
          if (order.transporter_id.toString() === prevTransporterId.toString()) {
            amount *= previousTransporter.assigned_transporter.freight_rate;
          } else {
            amount *= previousTransporter.previous_transporter.freight_rate;
          }
        } else {
          amount *= order.destinations[0].contract.freight_charges;
        }
      }
    } else {
      logger.error(`Wallet entry not created for the ${order.order_no} since slaCharge is empty`);
    }
    return amount;
  }
}

module.exports = AcceptanceBreach;
